module.exports = __webpack_public_path__ + "fonts/cffb686.woff2";